import "../pages.css";
import "./About.css";
import { LinkSection } from "../../components/LinkSection/LinkSection";
import { Separator } from "../../components/Separator/Separator";
import ResumeButton from "../../components/ResumeButton/ResumeButton";
import { PrimaryLink } from "../../components/Link/PrimaryLink";

export default function About() {
  return (
    <div className="PageBody">
      <div className="AboutContainer">
        <h1 className="PageHeader">Hello 👋</h1>
        <p className="PageText">
          My name is Joachim, and I am a backend-focused software engineer with a
          strong interest in building robust, scalable, and maintainable systems.
          I am currently working at{" "}
          <PrimaryLink url={"https://mymoney.se"} label={"MyMoney"} />, 
          where I serve as a tech lead, designing and developing backend services
          that power customer-facing products such as <PrimaryLink url="https://mymoney.se/pay" label="MyMoney Pay" />.
          <br />
          <br />
          I hold a Master of Science in Engineering (Civilingenjörsexamen) in Computer Science and Engineering
          from <PrimaryLink url={"https://www.lunduniversity.lu.se"} label={"Lund University"} /> (2015–2019), with a specialization in software development.
          During my studies, I built a strong foundation in algorithms, data structures, software design,
          while gaining experience with multiple programming languages and development methodologies.
          <br />
          <br />
          In addition to my educational background, I have several years of
          industry experience.
          Before my current role, I worked as a Compiler Developer at Modelon, where I implemented new compiler features and optimized performance, improving overall system efficiency.
          I also worked at Youcruit as a Fullstack Developer, contributing across both app and backend development using technologies such as Kotlin, GraphQL, gRPC, and PostgreSQL.
          <br/>
          <br />
          I'm proficient in Kotlin, Java, and TypeScript, Spring Boot, with hands-on experience designing APIs, building backend services, and working with databases like PostgreSQL and MySQL.
          I'm also comfortable with tools and infrastructure such as Docker, GitHub Actions, and Gradle to support development, testing, and deployment workflows.
          <br />
          <br />
          While my main passion lies in backend development, I also have experience
          with React and React Native, which helps me collaborate effectively across
          the stack and build systems with a strong understanding of end-user needs.
          <br />
          <br />
          I enjoy tackling complex problems, improving system performance, and
          continuously learning more about backend architecture, scalability, and
          software craftsmanship.
          <br />
          <br />
          Thanks for taking the time to check out my site!
        </p>
        <ResumeButton />
        <div className="LinkContainer">
          <LinkSection />
          <Separator />
        </div>
      </div>
    </div>
  );
}
